import {ChangeEvent, useContext, useEffect, useState} from "react";
import {
  CODE, CODE_SUCCESS,
  DEFAULT_PAGE_INDEX, INIT_SEARCH_OBJECT,
  KEY, REGEX,
  SELECTION_MODE,
  WF_TRACKER
} from "../../utils/Constant";
import {handlePagesChange, handleRowsPerPageChange, rowsForPage} from "../../utils/PageUtils";
import {ColumnActionsAssessmentPeriod, ColumnsAssessmentPeriod} from "../columns/AssessmentPeriods";
import WfStatusSummary from "../../workflows/components/WfStatusSummary";
import {deletePhieuNhapKho} from "../services/reportAssignment";
import {ConfirmDialog} from "../../component/ConfirmDialog";
import {toast} from "react-toastify";
import {ReportAssignmentContext} from "../ReportAssignment";
import {formatDateDTO} from "../../utils/FormatUtils";
import {INIT_GENERAL_VALUES, tempImg} from "../constants/reportAssignment";
import {getSummaryStatusWf} from "../../workflows/services/WfWorkflowsService";
import {TableCustom} from "../../component/table/table-custom/TableCustom";
import {TablePagination} from "../../component/table/components/TablePagination";
import InputSearch from "../../component/InputSearch";
import {AppContext} from "../../appContext/AppContext";
import TextField from "../../component/TextField";
import AssignEvaluationDialog from "../dialogs/AssignEvaluationDialog";
import {getPlans} from "../../build-plan/services/PlanServices";
import LabelRequired from "../../component/LabelRequired";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import {LIST_CRITERIA} from "../../criteria/constants/commons";
import {getListCriteria} from "../../criteria/services/CriteriaServices";

interface Props {
  className?: any;
}

export const ListDataTable = (props: Props) => {
  const {className} = props;
  const {setIsLoading} = useContext(AppContext);
  const [listData, setListData] = useState<any[]>([]);
  const {setListTableData, setDetailItem, typeForm} = useContext(ReportAssignmentContext);
  const [shouldOpenAssignEvaluationDialog, setShouldOpenAssignEvaluationDialog] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>({});
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>(INIT_SEARCH_OBJECT);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [criteriaType, setCriteriaType] = useState<any>(null);
  const [listCriteriaType, setListCriteriaType] = useState(Object.values(LIST_CRITERIA));
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });

  useEffect(() => {
    updatePageData().then(r => r);
  }, [criteriaType, searchData.endDate, page, rowsPerPage]);

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCloseDialog = () => {
    updatePageData();
    setListTableData([]);
    setDetailItem({});
    setShouldOpenAssignEvaluationDialog(false);
    setItemSelected({
      ...INIT_GENERAL_VALUES,
    });
  };

  const updatePageData = async () => {
    try {
      setIsLoading(true);
      const params = {
        pageIndex: page,
        pageSize: rowsPerPage,
        classId: criteriaType?.value,
        startDate: searchData?.startDate ? formatDateDTO(searchData?.startDate) : null,
        endDate: searchData?.endDate ? formatDateDTO(searchData?.endDate) : null,
      };
      const { data } = await getPlans(params);
      if (data?.code === CODE_SUCCESS) {
        const newData = data?.data?.content.map((item: any) => ({
          ...item,
          thumbnail: tempImg,
        }))
        setListData(newData);
        setConfigTable({
          totalPages: data?.data?.totalPages,
          totalElements: data?.data?.totalElements,
          numberOfElements: data?.data?.numberOfElements,
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetSummaryStatus = async () => {
    try {
      setIsLoading(true);
      const resSummary = await getSummaryStatusWf(
        WF_TRACKER.REPORT_ASSIGNMENT,
        {type: null}
      );
      if (CODE.SUCCESS === resSummary.data?.code) {
        setSummaryStatus(resSummary.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updatePageData();
    handleGetSummaryStatus();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, page]);


  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }

  const handleGetCriteria = async (item?: any) => {
    if (!item.id) {
      return;
    }

    try {
      setIsLoading(true);
      const params = {
        pageIndex: 1,
        pageSize: 9999,
        planId: item.id,
        planName: item?.name,
        classId: item.classId,
      };

      const { data } = await getListCriteria(params);
      if (data?.code === CODE_SUCCESS) {
        console.log("data?.data?.content", data?.data?.content);
        setDetailItem({
          ...item,
          listCriteria: data?.data?.content || []
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (item: any) => {
    console.log("item", item);
    setShouldOpenAssignEvaluationDialog(true);
    handleGetCriteria(item)
  }

  const columnsActions = ColumnActionsAssessmentPeriod({
    setDetailItem,
    setItemSelected,
    handleEdit,
  });

  const handleChangeFilter = (name: string, value: any) => {
    setSearchData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCriteriaType = (value: any) => {
    setCriteriaType(value);
    handleChangeFilter("plan", null);
    setListData([])
    setConfigTable({
      totalPages: 1,
      totalElements: 5,
      numberOfElements: 5,
    })
  }

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 ">
              <h4 className="text-title text-pri fw-bold fs-16 spaces mb-0 px-10 min-w-180">
                Danh sách đợt đánh giá
              </h4>
            </div>
            <div className="d-flex  mt-1 flex-column spaces width-100 ">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className="d-flex spaces align-items-center min-w-500 ml-10">
                    <LabelRequired
                      className="min-w-75px fw-bold"
                      label="Bộ Tiêu chí"
                    />
                    <AutocompleteV2
                      options={listCriteriaType}
                      value={criteriaType ?? null}
                      name="criteriaType"
                      onChange={handleCriteriaType}
                      className="spaces h-29 width-100"
                    />
                  </div>
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Năm"
                      name="year"
                      type="text"
                      value={searchData?.year || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                      isInvalid={searchData?.year && !REGEX.YEAR.test(searchData?.year)}
                      errors={"Năm không hợp lệ (1900 - 2100)"}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đợt"
                      name="doCreationToDate"
                      type="date"
                      className="flex"
                      value={searchData?.doCreationToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <b className="text-lable-input mb-0 spaces spaces mt-5 mr-5 form-label">Từ khóa</b>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm theo tên kế hoạch"
                      handleChange={handleChangeSearchData}
                      handleSearch={() => handlerSearchKeyWorld()}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4 radius-3"
                    />
                  </div>
                </div>
                <div className="spaces bg-white mb-0">
                  <TableCustom<any>
                    className={`spaces ${className || "h-bang-ds-phieu"}`}
                    data={listData}
                    columns={ColumnsAssessmentPeriod}
                    columnsActions={columnsActions}
                    verticalScroll={true}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={Number(configTable.totalPages)}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={3}/>}
                    className="border border-0"
                    customComponentClassName="min-w-700px"
                  />
                </div>
              </div>
            </div>
          </div>
          {shouldOpenAssignEvaluationDialog &&
            <AssignEvaluationDialog
              type={typeForm}
              show={shouldOpenAssignEvaluationDialog}
              onHide={handleCloseDialog}
              initialValues={{phanCongDanhGia: {...itemSelected}}}
              setInitialValues={setItemSelected}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default ListDataTable;
